import '.fo{line-height:var(--line-height-body);}.ssr-plugin'
import '.fi{margin-top:0px;}.ssr-plugin'
import '.fp{margin-bottom:1.5rem;}.ssr-plugin'
import { styled, Style } from 'inlines'

interface UnorderedListProps extends React.HTMLAttributes<HTMLUListElement> {
  style?: Style
}

export const UnorderedList = ({ children, style }: UnorderedListProps) => {
  return (
    <styled.ul className="fo fi fp"
      style={{
        '& > li': { marginTop: 0, marginBottom: '1rem' },
        ...style,
      }}
    >
      {children}
    </styled.ul>
  )
}
